import http from './request'
import axios from 'axios'
// import { compressVideo } from '@/utils'

// 上传图片
export function uploadImg(data, type = 'withdraw') {
  return http({
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    url: `/user/auth/upload/image?type=${type}`,
    data
  })
}

// 上传文件
export function uploadFile(data, type = 'withdraw') {
  return http({
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    url: `/user/auth/upload/file?type=${type}`,
    data
  })
}

/**
 * 上传文件
 */
export async function uploadFileByS3(file, cbUrl, cbUploadProgress, type = 'youtubeOut') {
  const data = { type, fileName: file.name }
  const res = await http({ url: '/user/auth/upload/getPreSignedUrl', method: 'post', data })
  if (res.code != 0) {
    return
  }
  await axios.put(res.data.path, file, {
    headers: { 'Content-Type': file.type },
    timeout: 600 * 1000,
    onUploadProgress: (progressEvent) => {
      const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total)
      cbUploadProgress && cbUploadProgress(percent)
    }
  })
  cbUrl(res.data.accessUrl || res.data.path.split('?')[0])
}
